
export function getBaseConstruct(itemT, showColored){
  if (itemT === 'BUTTON'){
    return {t:'BUTTON', s:baselineButtonStyle(), oc:{}};
  }else if (itemT === 'IMG'){
    if (showColored){
      return {"t":"IMG","oc":{},"s":{"src":"https://cdn.pixabay.com/photo/2022/03/20/14/56/astronaut-7081054_1280.png","borderWidth":{"t":"int","v":0},"width":{"t":"perc","v":100},"wh":{"t":"int","v":0},"ord":{"t":"int","v":0}},"info":{"oW":1280,"oH":1265,"rot":{"t":"dc","v":0},"sca":{"t":"dc","v":1},"cL":{"t":"dc","v":0},"cR":{"t":"dc","v":0},"cT":{"t":"dc","v":0},"cB":{"t":"dc","v":0}},"_na":"aa86"};
    }else{
      console.warn('image should not show here as it should go to image selector');
    }
  }else if (itemT === 'INPUT'){
    return {t:'INPUT', s:inputDefaults(), oc:{}};
  }else if (itemT === 'VIDEO'){
    var videoS = {videoId:'jHWKtQHXVJg', borderWidth:{t:'int',v:0}};
    videoS.width = {t:'perc', v:100};
    videoS.height = {t:'perc', v:100};
    videoS.vDimensions = {t:'raw', v:'embed-responsive-16by9'}
    return {t:'VIDEO', oc:{}, s:videoS};       
  }else if (itemT === 'ALERT'){
    return alertBaseline(0);
  }else if (itemT === 'LINECHART'){
    return {t:'LINECHART', oc:{}, s:{hRatio:{t:'int',v:60}, fontSize:{t:'px',v:12}, xColor:{t:'raw',v:'rgb(0, 0, 0)'}, yColor:{t:'raw',v:'rgb(0, 0, 0)'}}, d:{c0_ad6487a5:{_na:"7a5",s:{ord:{"t":"int","v":0},cap:{"t":"raw","v":"Bitcoin"},"strokeColor":{"t":"raw","v":"rgb(0, 0, 0)"},"dS":{"o":{"t":"f","i":104,"v":[{"t":"coin","v":"bitcoin"},{"t":"curr","v":"usd"},{"t":"ui","v":"30"}]},"r":{"t":"ListType","c":{"t":"Object","c":[{"t":"Date Time","n":"date",key:'a'},{t:"Decimal","n":"value",key:'b'}]}},"t":"formula","x":[{"t":"f","v":104},{"t":"g","v":"c0_4ccf773a"},{"t":"g","v":"c0_e90c4ea6"},{"t":"g","v":"c0_ce6ddab0"}],"y":{"c0_4ccf773a":{"x":[{"t":"coin","v":"bitcoin"}]},c0_e90c4ea6:{"x":[{"t":"curr","v":"usd"}]},c0_ce6ddab0:{"x":[{"t":"ui","v":"30"}]}}}}}}};
  }else if (itemT === 'BARCHART'){
    return {t:'BARCHART', oc:{}, s:{}};
  }else if (itemT === 'PIECHART'){
    return {t:'PIECHART', oc:{}, s:{}};
  }else if (itemT === 'TIMER'){
    const d = new Date();
    let time1 = Math.floor(d.getTime()/1000);
    return {t:'TIMER', s:{time:time1}, oc:{}};
  }else if (itemT === 'CONTAINER'){
    return {t:'CONTAINER', s:{styled:1}, oc:{}, i:{}};
  }else if (itemT === 'HFLEX'){
    return {t:'HFLEX', s:{}, oc:{}, i:{}};
  }else if (itemT === 'GALLERY'){
    if (showColored){
      return {"t":"GALLERY","oc":{},"s":{"srcList":{"s":{"c0_be27b608":{"ord":0,"v":"https://cdn.pixabay.com/photo/2014/04/03/00/40/space-suit-309023_1280.png"},"c0_26a8d463":{"ord":1,"v":"https://images.pexels.com/photos/2150/sky-space-dark-galaxy.jpg"},"c0_68cfba48":{"ord":2,"v":"https://cdn.pixabay.com/photo/2016/08/07/16/45/owl-1576572_1280.jpg"},"c0_9e63b4d5":{"ord":3,"v":"https://cdn.pixabay.com/photo/2017/03/15/02/47/ufo-2144977_1280.jpg"}}},"capList":{"s":{}},"textAlignment":{"t":"raw","v":"text-left"},"colWidthInternal":{"t":"bsu","v":3},"mvtIcon":{"t":"raw","v":"fluent:chevron-double-left-16-filled"},"maxHeight":{"t":"perc","v":95},"minHeight":{"t":"perc","v":95},"width":{"t":"perc","v":100},"ord":{"t":"int","v":1},"buttonsOutside":"","gHideWhen":"","hideCaption":1,"B":"","I":"","U":"","galleryHover":{"t":"raw","v":"galleryHover1"},"colWidth":{"t":"bsu","v":12}},"i":{},"_na":"afa8"};
    }
    return {t:'GALLERY', oc:{}, s:{srcList:{s:{}}, capList:{s:{}}, textAlignment:{t:'raw', v:'text-left'}, colWidthInternal:{t:'bsu',v:3}, mvtIcon:{t:'raw',v:'bxs:chevron-left-circle'}, galleryHover:{t:'raw',v:'galleryHover3'}, maxHeight:{t:'perc',v:95}, minHeight:{t:'perc',v:95}, width:{t:'perc',v:100}}, i:{}};
  }else if (itemT === 'SUMMARY'){
    function splitWord(text){
      return text.split('').map((aP, index)=>{
        return {u:aP};
      })
    }

    if (showColored){
      return {"t":"SUMMARY","s":{"detailsStyle":{"t":"raw","v":"Two"},"color":{"t":"raw","v":"rgb(234, 234, 234)"},"zIndex":{"t":"int","v":0},"gHideWhen":"","backgroundColor":{"t":"raw","v":"rgb(167, 108, 86)"},"ord":{"t":"int","v":1},"colWidth":{"t":"bsu","v":12}},"oc":{},"i":{"1":{"t":"SUMMARYDIV","s":{"text":"How Much Will It Cost?","ord":{"t":"int","v":0},"fontFamily":{"t":"font","v":"Raleway"},"textAlign":{"t":"align","v":"left"},"gHideWhen":""},"x":[{"t":"tb","v":splitWord("We will be selling it at 0.02ETH. We cannot guarantee what the price will be on Opensea."),"s":{"G":"Raleway"}}],"oc":{}},"c6_9e1a366d":{"t":"SUMMARYDIV","s":{"text":"How Can I Get Access To The Whitelist?","ord":{"t":"int","v":1},"fontFamily":{"t":"font","v":"Raleway"},"textAlign":{"t":"align","v":"left"}},"x":[{t:'tb',"v":splitWord("Join our discord. We release slots every Monday."),"s":{"G":"Raleway"}}],"oc":{},"_na":"c6_9e1a366d"},"c6_f249c99e":{"t":"SUMMARYDIV","s":{"text":"How Were They Created?","ord":{"t":"int","v":2},"fontFamily":{"t":"font","v":"Raleway"},"textAlign":{"t":"align","v":"left"},"gHideWhen":""},"x":[{"t":"tb","v":splitWord("By our brilliant artist, Brent, and our AI Engineer, Callie, who modified the animals to have differing expressions, clothings etc."),"s":{"G":"Raleway"}}],"oc":{},"_na":"c6_f249c99e"}},"pos":{"l":{"t":"vw","v":5},"t":{"t":"vh","v":25},"w":{"t":"vw","v":90},"ud":{"t":"int","v":0},"h":{"t":"vh","v":75},"lr":{"t":"int","v":0}},"_na":"a4ab"};
    }

    var i = {'1':{t:'SUMMARYDIV', s:{textAlignment:{t:'raw', v:'text-left'}, text:{t:'raw', v:'Title'}, ord:{t:'int',v:0}}, x:[{t:'br'}], oc:{}}};
    return {t:'SUMMARY', s:{detailsStyle:{t: 'raw', v: 'One'}, color:{t:'raw', v:'rgb(255, 255, 255)'}, backgroundColor:{t:'raw', v:'rgb(167, 108, 86)'}}, oc:{}, i};
  }else if (itemT === 'TABS'){
    return {t:'TABS', s:{sBackgroundColor:{t:'raw',v:'rgb(147, 197, 75)'}, sColor:{t:'raw',v:'rgb(0, 0, 255)'}, uBackgroundColor:{t:'raw',v:'rgb(241, 247, 231)'}, uColor:{t:'raw',v:'rgb(0, 0, 0)'}, indvPadding:{t:'int',v:0}, padding:{t:'int', v:6}}, oc:{}, i:{}};
  }else if (itemT === 'TABLE'){
    return {t:'TABLE', oc:{}, s:{firstRowHeader:{t:'int',v:1}, tableHover:{t:'raw',v:'table-hover'}}, i:{}, h:{}};
  }else if (itemT === 'PANEL'){
    return {i: {}, k:{}, al:{}, h:{t:'vh', v:100}, minHeight: {t:'em', v:40}, hl:{t:'int', v:0}, s:{}};
  }else if (itemT === 'FOOTER'){
    return {on:1,s:{},k:{}, al:{}, h:{t:'vh', v:100}, hl:{t:'int',v:0},i:{}};
  }else if (itemT === 'navBar'){
    return {on:1, i:{"a":navBarItemBaseline(),"c0_df14007b":{"t":"BUTTON","s":{"text":'Click Me',"buttonColor":{"t":"raw","v":"normalDarkPurple"},"ord":{"t":"int","v":1},"buttonSize":{"t":"raw","v":"btn-sm"}},"oc":{},"_na":"07b"}},ic:{},ir:{},s:{backgroundColor: {t: 'raw', v: 'rgb(255, 255, 255)'},icon: {t: 'raw', v: 'ion:menu-outline'}, iconColor: {t: 'raw', v: 'rgb(0, 0, 0)'}, iconHeight: {t: 'px', v: 30}, navbarTextShade:{t:'raw', v:'navbar-light'}}}
  }else if (itemT === 'CARD'){
    return {t:'CARD', s:{}, oc:{}, i:{}};
  }else if (itemT === 'ICON'){
    return icon();
  }else if (itemT === 'DIV'){
    return {t:'DIV', x:[{t:'br'}], s:{padding:{t:'int',v:10}, textAlignment:{t:'raw', v:'text-left'}, borderWidth:{t:'int',v:0}}};
  }

}

function baselineButtonStyle(){
  return {text:'Click Me', buttonColor:{'t':'raw','v':'primary'}};
}

function inputDefaults(){
    var placeholder = 'Placeholder Text';
    var valueString = '';
    var valueListString = {s:{}};
    var valueInteger = '0'
    var valueDecimal = '0';
    var valueDate = genericFormulaR({t:'UInteger', sp:'dateTime'});
    var valueDateTime = genericFormulaR({t:'UInteger', sp:'dateTime'});
    var options = {s:{}};
   return {placeholder, options, valueString, valueListString, valueInteger, valueDecimal, valueDate, valueDateTime, inputType:{t:'inputType',v:'Text String'}, disabled:0, withPreview:1, textAlignment:{t:'raw',v:'text-left'}};
}

function genericFormulaR(type){ //to change out to others.

  function getO(type){
    return {t:'dt',v:Math.floor(new Date()/1000)};
  }

  function getX(type){
    var o = getO(type);
    return [o];
  }

  var o = getO(type);
  var x = getX(type);

  return {t:'formula', x, o, r:type,y:{}};
}

export function icon(){
  var iconS = {icon:{t:'raw', v:'ant-design:rocket-outlined'}, iconColor:{t: 'raw', v: 'rgb(0, 0, 0)'}, iconHeight:{t:'px',v:40}};
  return {t:'ICON', oc:{}, s:iconS};

}
function alertBaseline(orderNos){
  var s = {buttonColor: {t: 'raw', v: 'primary'}};
  var oc = {};
  var k = {'c0_6fe20f82':{'t':'CONTAINER','s':{'ord':{'t':'int','v':0},'styled':1},'oc':{},'i':{'c0_2c05efd9':{'t':'HFLEX','s':{'ord':{'t':'int','v':0},'justify':{'t':'raw','v':'bx:align-left'}},'oc':{},'i':{'c0_f7020ca2':{'t':'DIV','x':[{'t':'tb','v':[{u:'C'}, {u:'h'}, {u:'a'}, {u:'n'}, {u:'g'}, {u:'e'}, {u:' '}, {u:'t'}, {u:'e'}, {u:'x'}, {u:'t'}, {u:' '}, {u:'h'}, {u:'e'}, {u:'r'}, {u:'e'}],'s':{}}],'s':{textAlignment:{t:'raw', v:'text-left'}, 'padding':{'t':'int','v':10},'verticalAlign':{'t':'align','v':'top'},'borderWidth':{'t':'int','v':0},'ord':{'t':'int','v':1}, 'colWidth':{'t':'bsu','v':11},'indvPadding':{'t':'int','v':1},'paddingLeft':{'t':'int','v':20},'paddingTop':{'t':'int','v':10},'paddingBottom':{'t':'int','v':10}},'_na':'ca2'},'c0_1e2a8d12':{'t':'ICON','oc':{'click':{'t':'hideOwnBanner'}},'s':{'icon':{'t':'raw','v':'charm:cross'},'iconColor':{'t':'raw','v':'rgb(0, 0, 0)'},'iconHeight':{'t':'px','v':20},'ord':{'t':'int','v':0},'colWidth':{'t':'bsu','v':1},'padding':{'t':'int','v':5},'ml':{'t':'bsu','v':0}},'_na':'d12'}},'_na':'fd9'}},'_na':'f82'}};

  // var x = [{t:'br'}];
  s.ord = {t:'int',v:orderNos}
  return {s, oc, k};
}

export function navBarItemBaseline(){
  return {'t':'navBrand','s':{'text':'Brand','src':'https://www.cues.sg/client_pictures/108_jGMeTdU4.png','maxWidth':{'t':'px','v':30},'maxHeight':{'t':'px','v':24},'spacingGap':{'t':'px','v':10},'gotLogo':1,'borderWidth':{'t':'int','v':0},'ord':{'t':'int','v':0},'logoWidth':{'t':'px','v':100}},'oc':{},'_na':'1'};
}

